export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./banner-native.vue?vue&type=template&id=8be15828&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/banner-native/banner-native.vue?vue&type=template&id=8be15828&
// module id = 1327
// module chunks = 0